// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".white-overlay{position:fixed;background-color:#fff;top:0;left:0;width:100%;height:100%;z-index:999999;transition:.5s}.fadeoverlay-enter-active,.fadeoverlay-leave-active{transition-duration:1s;transition-property:opacity;transition-timing-function:ease;opacity:0}.fadeoverlay-enter,.fadeoverlay-leave-active{opacity:0}", ""]);
// Exports
module.exports = exports;
